const genAnswer = function (qu, value, refItem) {
  return qu.optionList.filter(item => item.value !== 0).map(item => {
    return {
      descId: item.id,
      answer: item.value
    }
  })
}

const setAnswer = function (qu, valueMap, otherAnswerMap) {
  let configValue = []
  Object.keys(valueMap).forEach((key) => {
    const values = valueMap[key]
    values.forEach((val, index) => {
      configValue.push(index)

      if (this.optionList.find(item => item.id === val)) {
        this.optionList.find(item => item.id === val).value = index + 1 
      }
    })
  })
  const selArr = this.optionList.filter(item => item.value).sort((a, b) => a.value - b.value)
  const unSelArr = this.optionList.filter(item => !item.value)
  this.optionList = [...selArr, ...unSelArr]
  this.value = configValue
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/SortBox/answer.js